import { http } from "./http";

// "Change country": allowed while nothing is verified or earned yet. The next
// money button asks for the country again.
export const payoutCountryApi = {
  reset: () => http.post<{ ok: true }>("/payout-country/reset"),
};
